import React from 'react'
import { Grid, Container } from 'semantic-ui-react';
import MediaQuery from 'react-responsive'
import RightSection from '../RightSection';
import Navbar from './navbar/Navbar';
import LeftSidebar from '../LeftSidebar';

const Layout = (props) => {
    return (
        <Navbar {...props}>
            <div id="HEADER" className="primary-background">
                <Container className="body-background palm-nudge-sides">
                    <Grid padded stackable>
                        {props.children}
                    </Grid>
                </Container>
            </div>
        </Navbar>
    );
}

export default Layout;